import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from '../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../configs/app-interface.config';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CreateGyanService {
    url: any;
    domainUrl = environment.apiurl;
    gyanDomainURL = environment.gyanApiUrl;
    public callWebsocket: Subject<any> = new Subject();
    pksSelected = false; // flag used to check if PKS is selected while initiating advanced query gyan and navigation is done based on this flag

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {}

    submitGyan(reqBody: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.submitGyan.initiatesearch;
        return this.http.post(url, reqBody);
    }

    saveDraftGyan(reqBody: any): Observable<any> {
        const url = this.gyanDomainURL + this.config.apis.submitGyan.savedraftgyan;
        return this.http.post(url, reqBody);
    }

    getSavedDrafts(pageNo: any) {
        const apiUrl = this.gyanDomainURL + this.config.apis.submitGyan.getdrafts + '?pageNo=' + pageNo;
        return this.http.post(apiUrl, {});
    }

    deleteDraft(id: any) {
        const apiUrl = this.gyanDomainURL + this.config.apis.submitGyan.deletedraft + '?id=' + id;
        return this.http.delete(apiUrl);
    }

    // callMDS(id: any): Observable<any> {
    //     const url = this.domainUrl + this.config.apis.gyanSearch.getgyanmultidocsummary + '?' + 'gyanId' + '=' + id;
    //     return this.http.get(url);
    // }

    callMDS(id: any): Observable<HttpResponse<any>> {
        const url = `${this.domainUrl}${this.config.apis.gyanSearch.getgyanmultidocsummary}?gyanId=${id}`;
        return this.http.get<any>(url, { observe: 'response' });
    }

    // SubmitOldGyan(gyanObj: any, gyanCookie: string): Observable<any> {
    //     const body = new FormData();
    //     body.append('concept', new Blob([JSON.stringify(gyanObj)], { type: 'application/json' }));

    //     const url = this.gyanDomainURL + this.config.apis.submitGyan.initiateOldGyanSearch;
    //     console.log(url);
    //     return this.http.post(url, body);
    // }
}
